module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    key: _vm.handler,
    staticClass: "ql-position-cue-marker",
    style: ({
      color: _vm.cueColor(_vm.cue),
      transform: _vm.transformStyle(_vm.cue),
      '--cue-bgColor': _vm.cueColor(_vm.cue)
    }),
    attrs: {
      "handles": [],
      "x": _vm.cuePosLeft,
      "y": _vm.cuePosTop,
      "w": _vm.cuePosWidth,
      "h": _vm.cuePosHeight,
      "minw": 2,
      "minh": 2,
      "parent": true,
      "draggable": _vm.editable && !_vm.locked
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    },
    nativeOn: {
      "mousedown": function($event) {
        return _vm.selectForCopy.apply(null, arguments)
      }
    }
  }, [_c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v(_vm._s(_vm.layer ? _vm.layer.title + ' ' + _vm.cue.title : ''))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53e51030","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/cues/cue-position-marker.vue
// module id = 1244
// module chunks = 21